<template>
  <div class="reaction-icons">
    <div
      v-for="icon in icons"
      :key="icon"
      class="reaction-icons__icon"
      :class="{ 'reaction-icons__icon--active': isSelected(icon) }"
      @click="selectIcon(icon)"
    >
      {{ icon }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icons: {
      type: Array,
      default: () => []
    },
    selectedIcon: {
      type: String,
      default: undefined
    }
  },
  emits: ['input'],
  methods: {
    selectIcon(icon) {
      this.$emit('input', icon)
    },
    isSelected(icon) {
      if (!this.selectedIcon) {
        return false
      }
      if (this.selectedIcon === icon) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.reaction-icons {
  background: var(--gl-color-shades-white);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: 100px;
  display: flex;
  padding: var(--gl-spacing-02);

  &__icon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--gl-spacing-06);
    font-size: var(--gl-font-size-lg);

    &:hover,
    &--active {
      background: var(--gl-color-shades-gray-20);
      border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
      border-radius: 100%;
    }
  }
}
</style>
